export default "__VITE_ASSET__Dsy7MOZb__"